module.exports = __webpack_public_path__ + "img/top_option-4.d8dff2c0.png";